import apiService from './api';
import { IPlace } from 'src/models/interfaces/place';

export class PlaceService {
  public getByBuildingId(buildingId: number): Promise<{ data: IPlace[] }> {
    return apiService.get(`/place/building/${buildingId}`);
  }
}

const placeService = new PlaceService();
export default placeService;